var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtmhomeleft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 467,
    height: 140,
    viewBox: "0 0 467 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_174_736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467 93H420.254V139.745H467V93Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.254 93H373.509V139.745H420.254V93Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.185 139.745H233.439V186.491H280.185V139.745Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 139.745H420.254V186.491H467V139.745Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.115 93H93.3694V139.745H140.115V93Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.509 93H326.763V139.745H373.509V93Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.254 139.745H373.509V186.491H420.254V139.745Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7903 93H0.0449219L0.0449219 139.745H46.7903L46.7903 93Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.185 93H233.439V139.745H280.185V93Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.605 93H186.86V139.745H233.605V93Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5357 93H46.7903L46.7903 139.745H93.5357V93Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.86 93H140.115V139.745H186.86V93Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.93 93H280.185V139.745H326.93V93Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.93 139.745H280.185V186.491H326.93V139.745Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3613 104.751L11.7161 93.1062L0.070831 104.751L11.7161 116.397L23.3613 104.751Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.666 104.714L35.0208 93.0685L23.3755 104.714L35.0208 116.359L46.666 104.714Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3989 128.056L11.7537 116.411L0.108429 128.056L11.7537 139.701L23.3989 128.056Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7036 128.019L35.0583 116.373L23.4131 128.019L35.0583 139.664L46.7036 128.019Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7246 93L93.3694 104.645V93H81.7246Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0798 93H58.4351L93.3693 127.934V116.29L70.0798 93Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7903 93L93.3693 139.745H81.7245L46.7903 104.645V93Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7903 116.29L70.0798 139.746H58.435L46.7903 127.934V116.29Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.86 127.934L175.049 139.746H186.86V127.934Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.86 116.289V104.645L151.76 139.745H163.404L186.86 116.289Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.86 93L140.115 139.745V127.934L175.049 93H186.86Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.404 93L140.115 116.29V104.645L151.759 93H163.404Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.185 116.29V139.579H256.895C256.729 126.77 267.209 116.29 280.185 116.29Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.474 139.746H280.185V116.29C292.994 116.29 303.474 126.77 303.474 139.746Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.185 163.035V139.745H303.474C303.474 152.555 292.994 163.035 280.185 163.035Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.729 139.745H280.018V163.035C267.209 163.035 256.729 152.555 256.729 139.745Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.864 104.645H338.575V127.934H361.864V104.645Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.443 104.645H385.154V127.934H408.443V104.645Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.509 163.035L396.798 139.745L420.254 163.035H373.509Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.87 116.298L443.58 93.0071L420.289 116.298L443.58 139.588L466.87 116.298Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.107 116.297L443.462 104.652L431.817 116.297L443.462 127.943L455.107 116.297Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7903 139.564L46.7903 186.309H93.5357V139.564H46.7903Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4751 139.669V186.414H140.22V139.669H93.4751Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.16 139.608V186.354H186.905V139.608H140.16Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3691 139.745V186.491H140.114C140.114 160.54 119.154 139.745 93.3691 139.745Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.082 139.736L46.7915 163.027L70.082 186.317L93.3724 163.027L70.082 139.736Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.115 186.324L163.404 163.035L140.115 139.745V186.324Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.115 92.7454V46L326.369 46V92.7454H373.115Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.43 92.8513V46.106L279.685 46.106V92.8513H326.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.745 92.7905V46.0452L233 46.0452V92.7905H279.745Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.452 92.6853L279.808 81.0405V92.6853H291.452Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.097 92.6852H314.742L279.808 57.751V69.3957L303.097 92.6852Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.387 92.6852L279.808 46.1062H291.452L326.387 81.0405V92.6852Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.387 69.3957L303.097 46.1062H314.742L326.387 57.751V69.3957Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.796 92.7482L373.086 69.4578L349.796 46.1673L326.506 69.4577L349.796 92.7482Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.063 46.1069L256.352 69.3964L233.063 92.6859V46.1069Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1 46L-1 92.7454H45.7454L45.7454 46L-1 46Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6848 46.1054L45.6848 92.8507H92.4302V46.1054L45.6848 46.1054Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3694 46.0448V92.7902H139.115V46.0448L92.3694 46.0448Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5789 46.1819L45.5789 92.9273H92.3242C92.3242 66.9761 71.3637 46.1819 45.5789 46.1819Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5789 57.8267L45.5789 92.7609H80.5131C80.6795 73.4639 65.0422 57.8267 45.5789 57.8267Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2917 46.1729L-0.998779 69.4634L22.2917 92.7538L45.5822 69.4634L22.2917 46.1729Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3242 92.7609L115.614 69.4714L92.3242 46.1819V92.7609Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.685 46.0007V92.7461H232.43V46.0007L185.685 46.0007Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 46.0618V92.8071H185.745V46.0618L139 46.0618Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.334 81.1777C168.766 81.1777 173.979 75.9642 173.979 69.5329C173.979 63.1017 168.766 57.8882 162.334 57.8882C155.903 57.8882 150.69 63.1017 150.69 69.5329C150.69 75.9642 155.903 81.1777 162.334 81.1777Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.08 57.7217C215.568 57.7217 220.725 62.8786 220.725 69.3664C220.725 75.8542 215.568 81.0112 209.08 81.0112C202.592 81.0112 197.435 75.8542 197.435 69.3664C197.435 63.045 202.592 57.7217 209.08 57.7217Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.115 46.7454V0L93.3694 0V46.7454L140.115 46.7454Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4302 46.8513V0.105957L46.6848 0.105957L46.6848 46.8513L93.4302 46.8513Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7454 46.7905L46.7454 0.045166L-1.52588e-05 0.045166L-1.52588e-05 46.7905L46.7454 46.7905Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4524 46.6853L46.8076 35.0405V46.6853H58.4524Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0971 46.6852L81.7419 46.6852L46.8076 11.751V23.3957L70.0971 46.6852Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3866 46.6852L46.8076 0.106201L58.4524 0.106201L93.3866 35.0405V46.6852Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3867 23.3957L70.0972 0.106201L81.7419 0.106201L93.3867 11.751V23.3957Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.796 46.7482L140.086 23.4578L116.796 0.167291L93.5055 23.4577L116.796 46.7482Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0627441 0.106934L23.3522 23.3964L0.0627441 46.6859L0.0627441 0.106934Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_174_736"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 467,
    height: 140,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtmhomeleft);
export default __webpack_public_path__ + "static/media/btmhomeleft.6e737dd574e3e4e12b6539ef5ba31517.svg";
export { ForwardRef as ReactComponent };